import React, {FC, useEffect, useState} from 'react';
import {GxButton, GxIcon, GxPhoneInput} from '@garpix/garpix-web-components-react';
import {useStoreon} from 'storeon/react';
import cnBind from 'classnames/bind';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import { IUser } from '@/types';
import styles from './styles/index.module.scss';
import {PhoneIcon, PlusIcon} from '../../assets';
import {ATC_TYPE} from '../../const';
import {COLOR_TYPE_ATC} from './const';
import {MODALS_NAMES} from '../../const/modals';
import useModal from '../../hooks/useModal';
import {IPhoneSidebar, MyCustomCSS} from './interfaces';

const PhoneSidebar: FC<IPhoneSidebar> = ({isOpenSidebar}) => {
    const cn = cnBind.bind(styles);
    const { dispatch, infoCall } = useStoreon<State, Events>('infoCall');
    const {phone, type} = infoCall;
    const { openModal } = useModal();
    const [isFlagInfoBlock, setIsFlagInfoBlock] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<IUser | null>(null)

    const openModalUser = (phoneUser?: string): void => {
        openModal(MODALS_NAMES.modalUser, { isEdit: false, userId: null, user: phoneUser ? {phone: `+${phoneUser}`} : userInfo })
    }

    const close = () => {
      dispatch('modalCall/setInfo', {type: null})
    }

    const saveUserInfo = () => {
      if (!userInfo) return

      dispatch('selectedUser/set', {
        ...userInfo,
        value: userInfo.id,
        label: `${userInfo.first_name || ''} ${userInfo.last_name || ''}`
      })

      close()
    }

  useEffect(() => {
    if (phone && (type === 'INCOMING' || type === 'OUTGOING')) {
      api.user.getUsers({
        search: phone
      }).then(({ results }) => {
        setUserInfo(results.length > 0 ? results[0] : null)
      })
    }
  }, [type])

  const userButton = userInfo ? {
    label: 'Копировать',
    handleClick: saveUserInfo
  } : {
    label: 'Создать',
    handleClick: () => {
      openModalUser(phone)
    }
  };

    return (
      <>
        {(type !== 'COMPLETED' && type !== 'CANCELLED' &&  type !== 'DEFAULT' && type !== null && type !== 'out' && type !== 'in')  &&
        <div className={styles['container']} style={{'--phone-color': COLOR_TYPE_ATC[type],} as MyCustomCSS}>
          <div className={styles['phone-block']}  onClick={() => setIsFlagInfoBlock(!isFlagInfoBlock)} tabIndex={0} role='button'>
            <GxIcon src={PhoneIcon} className={cn({
                'phone-block--icon': true,
                'phone-block--icon_accepted': type === 'ACCEPTED'
            })}
                    />
            {isOpenSidebar && <span className={styles['phone-block--info']}>{ATC_TYPE[type]}</span>}
          </div>

          <div className={cn({
              wrapper: true,
              'wrapper--active': isFlagInfoBlock,
              'wrapper--open-sidebar': isOpenSidebar && isFlagInfoBlock
          })}
          >
            <div className={styles['header']}>
            <div className={styles['header__container']}>
              <GxIcon className={styles['header__container--icon']} src={PhoneIcon}/>
              <h2 className={styles['header__container--title']}>{ATC_TYPE[type]}</h2>
              <GxIcon src={PlusIcon} className={cn(styles['header__container--icon'],styles['header__container--close'])} onClick={close}/>
            </div>
          </div>
            <div className={styles['main']}>
              <label htmlFor="phone" className={cn(styles['phone'], styles['phone--label'])}>
                <span>Телефон:</span>
                <GxPhoneInput
                  value={phone}
                  className={cn({
                      'phone__input': true,
                      'phone__input--incoming': type === 'INCOMING',
                      'phone__input--outgoing': type === 'OUTGOING',
                  })}
                  disabled={type !== 'DEFAULT'}
                />
                <GxButton
                  className={styles['phone__save']}
                  type='button'
                  onClick={userButton.handleClick}
                >
                  {userButton.label}
                </GxButton>
              </label>
                {type !== 'DEFAULT' &&
                <div className={styles['footer']}>
                  <div className={styles['info']}>
                    {userInfo ?
                      <>
                        <p className={styles['info--title']}>{`${userInfo.last_name} ${userInfo.first_name} ${userInfo.patronymic_name ? userInfo.patronymic_name : ''}`}</p>
                        <div className={styles['info__block']}>
                          <p>
                            <span>Труба:</span> {userInfo.tube_user_type.title}
                          </p>
                          <p>
                            <span>Волна:</span> {userInfo.wave_user_type.title}
                          </p>
                        </div>
                      </>
                      :
                      <p className={styles['info--title']}>
                        Неизвестный номер...
                      </p>
                    }
                  </div>
                </div>
                }
            </div>
          </div>
        </div>
        }
      </>
    );
};

export default PhoneSidebar;
